import React from 'react';
import {Link} from 'react-router-dom';
import constants from '../../../constants';
import LinesEllipsis from 'react-lines-ellipsis'

import './style.scss';
import './mobile.scss';
import Button from '../../Button';
import ProductPlateItemPrice from './Price';

const ProductsListPlateItem = ({product, city_slug, ...props}) => {
  const
    handleAddToCart = () => {
      props.onAddToCart(product.id);
    },
    discount = product.discountPercents,
    path = constants.ROUTES.REGIONAL_PRODUCT_PATH(city_slug, product.rubric_path, product.id_with_slug);

  return (
    <div
      className='products-list-item'
      itemProp="itemListElement"
      itemScope
      itemType="https://schema.org/Product"
    >
      <meta itemProp='name' content={product.name} />
      <div className='products-list-item__top'>
        <Link itemProp="url" to={path} className='products-list-item__image'>
          { product.image ?
            <img itemProp="image" loading="lazy" src={product.image.big_image_url} alt={product.image.alt || product.name} />
            : null}
          <div className='products-list-item__image-bg' />
        </Link>

        <div className='products-list-item__labels'>
          {discount ? <div className='products-list-item__label products-list-item__label_discount'>-{product.discountPercents}%</div> : null}
          {product.stock ? <div className='products-list-item__label products-list-item__label_stock'>акция</div> : null}
          {product.hit ? <div className='products-list-item__label products-list-item__label_hit'>хит</div> : null}
          {product.latest ? <div className='products-list-item__label products-list-item__label_new'>NEW</div> : null}
        </div>

        <ProductPlateItemPrice offer={product} />

        <Link to={path} className='products-list-item__title' title={product.name}>
          <LinesEllipsis
            text={product.name}
            maxLine='2'
            ellipsis='...'
            trimRight
            basedOn='letters'
          />
        </Link>
        {/*<div className='products-list-item__price'>*/}
        {/*  <div className='products-list-item__prices'>*/}
        {/*    {*/}
        {/*      product.unitsPrices.map((unitPrice, idx) => {*/}
        {/*        return (*/}
        {/*          <div key={idx} className='products-list-item__prices-item'>*/}
        {/*            {priceWithCurrency(unitPrice.price)}*/}
        {/*            <span> за {unitPrice.unit}</span>*/}
        {/*          </div>*/}
        {/*        )*/}
        {/*      })*/}
        {/*    }*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>
      <div className='products-list-item__bottom'>
        <div className='products-list-item__reminder'>
          {
            product.reminder > 0 ?
              <>
                <span>В наличии</span>
                {product.reminderStrInBaseUnits}
              </>
              : <span>Под заказ</span>
          }
        </div>
        <div className='products-list-item__actions'>
          {
            props.inCart ?
              <Button primary to={constants.ROUTES.CART} className='sm'>Добавлен</Button>
              : <Button onClick={handleAddToCart} primary className='sm' loader={!!props.sendingToCart}>В корзину</Button>
          }
        </div>
      </div>
    </div>
  );
}

export default ProductsListPlateItem;
